var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41457 13.7069C2.9389 17.1825 2.9389 22.8177 6.41457 26.2934C9.89023 29.769 15.5254 29.769 19.0011 26.2934L25.1293 20.1651C25.7151 19.5793 26.6649 19.5793 27.2506 20.1651C27.8364 20.7509 27.8364 21.7006 27.2506 22.2864L22.7679 26.7692C26.2646 29.7611 31.5312 29.6025 34.8403 26.2934C38.3159 22.8177 38.3159 17.1825 34.8403 13.7069C31.3646 10.2312 25.7294 10.2312 22.2538 13.7069L16.1255 19.8351C15.5397 20.4209 14.59 20.4209 14.0042 19.8351C13.4184 19.2493 13.4184 18.2996 14.0042 17.7138L18.4869 13.2311C14.9902 10.2392 9.72365 10.3978 6.41457 13.7069ZM20.6274 11.1177C15.9547 6.94393 8.77891 7.09989 4.29325 11.5856C-0.353991 16.2328 -0.353991 23.7675 4.29325 28.4147C8.77891 32.9004 15.9547 33.0563 20.6274 28.8826C25.3001 33.0563 32.4759 32.9004 36.9616 28.4147C41.6088 23.7675 41.6088 16.2328 36.9616 11.5856C32.4759 7.09989 25.3001 6.94393 20.6274 11.1177Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.231d93742396c50f2b8dfdd5347abdb1.svg";
export { ForwardRef as ReactComponent };